function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="22" height="22" viewBox="0 0 22 22" {...props}><path d="M10.81 0C4.84 0 0 4.84 0 10.81c0 5.97 4.84 10.81 10.81 10.81 5.97 0 10.81-4.84 10.81-10.81C21.62 4.84 16.78 0 10.81 0zm1.274 10.81l2.966 2.966a.9.9 0 1 1-1.274 1.274l-2.966-2.966-2.966 2.966a.9.9 0 1 1-1.274-1.274l2.966-2.966L6.57 7.844A.9.9 0 1 1 7.844 6.57l2.966 2.966 2.966-2.966a.9.9 0 1 1 1.274 1.274l-2.966 2.966z" fillRule="nonzero" /></svg>;
});